import { AccountRow } from './accountRow';
import { Base } from './base';

export const Card = {
	AccountRow,
	Base,
};
